














































































































































































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { mobile, accountValidation, pwdValidation } from '@root/utils/validators';
import { createBusiness, editBusiness, findParkByOrgId } from '@/api/discount-management/index';
import OrganizationSearch from '../../../../components/organization-search/index.vue';
import Utils from '@root/utils/common';
import ModalConfig from '@/components/modal-config/index.vue';
import { isShiDaisy } from '@root/utils/env';
export interface IForm {
  name: string; // 商户名称
  type: string; // 商户类型：01普通商户 02酒店商户 03中央服务台
  parkId: string; // 车场id
  loginId: string; // 登录账户id
  loginPwd: string; // 登录账户密码
  linkman: string; //联系人
  mobile: string; //手机号
  takePhotosStatus: string; // 拍照状态：00 禁用 01 启用
  projectName: string;
  bizType: string;
  parkIds: any;
  orgdepId: string;
  applyPark: string;
  companyName: string; //公司名称	同商户名称 不可修改
  saleCode: string; //纳税人识别号
  invoiceType: string; //	发票类型	01增值税普通发票		02增值税专用发票
  saleAddress: string; //注册地址
  saleTel: string; //注册电话
  saleBank: string; //开户银行
  saleBankNo: string; //银行账户
  email: string; //电子发票接收邮箱
  merchantAccountId: string;
}
const pwdNewValidation = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
    if (!value) callback();
    else {
      if (value.length < 6 || value.length > 10) {
        callback(new Error(tip));
      } else if (reg.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
@Component({
  name: 'AddEditModal',
  components: { ParkingLotSearch, OrganizationSearch, ModalConfig }
})
export default class AddEditModal extends Vue {
  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否显示机构
  @Prop({ type: Boolean, default: false })
  showFlag!: boolean;

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;
  // 校验字段方法

  modefind = '1';

  invoiceTypeList: any[] = [
    { label: '普通发票', value: '00' },
    { label: '增值税专用发票', value: '01' },
    { label: '增值税普通发票', value: '02' },
    { label: '增值税电子普通发票', value: '03' }
  ];
  validatorsPhone = mobile;
  validatorAccount = accountValidation;
  validatorPwd = pwdNewValidation;
  form: any = null;
  businessTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  // isSDShangYe = true
  isSDShangYe: boolean = isShiDaisy;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  id = '';
  confirmLoading: boolean = false;
  get errorMsg() {
    // if (this.isSDShangYe) return '管理员不能为空'
    return '联系人不能为空';
  }

  filterOption(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  parkTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_biz_type);
  //form初始化
  init() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          let {
            id,
            name,
            type,
            parkId,
            loginId,
            linkman,
            mobile,
            takePhotosStatus,
            projectName,
            bizType,
            parkIds,
            orgdepId,
            applyPark,
            companyName, //	公司名称	同商户名称 不可修改 1230版本可修改 不再是商户名称
            saleCode, //	纳税人识别号
            invoiceType, //	发票类型	01增值税普通发票		02增值税专用发票
            saleAddress, //	注册地址
            saleTel, //注册电话
            saleBank, //	开户银行
            saleBankNo, //	银行账户
            email, //电子发票接收邮箱
            pkInvoiceId,
            merchantAccountId
          } = this.data;
          // if (companyName !== name) {
          //   companyName = name;
          // }
          // @ts-ignore
          this.pkInvoiceId = pkInvoiceId;
          this.id = id;
          if (type === '04') {
            this.getpark(orgdepId);
          }

          return {
            companyName: this.$form.createFormField({
              value: companyName
            }),
            saleCode: this.$form.createFormField({
              value: saleCode
            }),
            invoiceType: this.$form.createFormField({
              value: invoiceType
            }),
            saleAddress: this.$form.createFormField({
              value: saleAddress
            }),
            saleTel: this.$form.createFormField({
              value: saleTel
            }),
            saleBank: this.$form.createFormField({
              value: saleBank
            }),
            saleBankNo: this.$form.createFormField({
              value: saleBankNo
            }),
            email: this.$form.createFormField({
              value: email
            }),
            applyPark: this.$form.createFormField({
              value: applyPark
            }),
            orgdepId: this.$form.createFormField({
              value: orgdepId
            }),
            parkIds: this.$form.createFormField({
              value: parkIds
            }),
            bizType: this.$form.createFormField({
              value: bizType
            }),
            projectName: this.$form.createFormField({
              value: projectName
            }),
            name: this.$form.createFormField({
              value: name
            }),
            type: this.$form.createFormField({
              value: type
            }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            loginId: this.$form.createFormField({
              value: loginId
            }),
            linkman: this.$form.createFormField({
              value: linkman
            }),
            mobile: this.$form.createFormField({
              value: mobile
            }),
            takePhotosStatus: this.$form.createFormField({
              value: takePhotosStatus
            }),
            merchantAccountId: this.$form.createFormField({
              value: merchantAccountId
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          console.log(this.businessTypeOptions, 'this.businessTypeOptions');
          return {
            takePhotosStatus: this.$form.createFormField({
              value: '01'
            }),
            type: this.$form.createFormField({
              value: '01'
            })
            // mobile: this.$form.createFormField({
            //   value: '15062910222',
            // }),
            // linkman: this.$form.createFormField({
            //   value: '奚倩',
            // }),
            // loginId: this.$form.createFormField({
            //   value: 'ruixingee',
            // }),
            // loginPwd: this.$form.createFormField({
            //   value: '123456ww',
            // }),
            // name: this.$form.createFormField({
            //   value: '瑞幸212',
            // }),
            // companyName: this.$form.createFormField({
            //   value: '瑞幸',
            // }),
            // saleCode: this.$form.createFormField({
            //   value: 'saleCode',
            // }),
            // invoiceType: this.$form.createFormField({
            //   value: 'invoiceType',
            // }),
            // saleAddress: this.$form.createFormField({
            //   value: 'saleAddress',
            // }),
            // saleTel: this.$form.createFormField({
            //   value: 'saleTel',
            // }),
            // saleBank: this.$form.createFormField({
            //   value: 'saleBank',
            // }),
            // saleBankNo: this.$form.createFormField({
            //   value: 'saleBankNo',
            // }),
            // email: this.$form.createFormField({
            //   value: 'email',
            // }),
          };
        }
      });
    }
  }

  handleName(e: { target: { value: any } }) {
    this.form.setFieldsValue({ companyName: e.target.value });
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (values.parkIds && values.parkIds === 'all') {
          values.applyPark = '00';
          const parks = this.parkList.map((item: any) => {
            return item.value;
          });
          values.parkIds = parks.join(',');
          console.log(parks, 'parks-------------->>>>>>>>>');
        } else {
          values.applyPark = '01';
        }
        if (values.parkIds) {
          values.parkIds = values.parkIds.join(',');
        }
        this.onAddOrEdit({
          takePhotosStatus: '01',
          merchantAccountId: this.data ? this.data.merchantAccountId : '',
          ...values
        });
      }
      if (err) {
        if (values.name === '' || values.name === undefined) return this.$message.warning('商户名称不能为空');
        // if (values.orgdepId === '' || values.orgdepId === undefined) return this.$message.warning('所属机构不能为空')
        if (values.type === '' || values.type === undefined) return this.$message.warning('商户类型不能为空');
        // if (values.parkIds === '' || values.parkIds === undefined) return this.$message.warning('适用车场不能为空')
        if (values.loginId === '' || values.loginId === undefined) return this.$message.warning('登录账户不能为空');
        // if (values.loginPwd === '' || values.loginPwd === undefined) return this.$message.warning('登录密码不能为空')
        if (values.mobile === '' || values.mobile === undefined) return this.$message.warning('手机号不能为空');
        if (values.linkman === '' || values.linkman === undefined) return this.$message.warning('联系人不能为空');
        if (this.isSDShangYe && (values.companyName === '' || values.companyName === undefined))
          return this.$message.warning('公司名称不能为空');
        if (this.isSDShangYe && (values.saleCode === '' || values.saleCode === undefined))
          return this.$message.warning('纳税人识别号不能为空');
        if (this.isSDShangYe && (values.invoiceType === '' || values.invoiceType === undefined))
          return this.$message.warning('发票类型不能为空');
      }
    });
  }
  //新增保存表单
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return;
    this.confirmLoading = true;
    try {
      if (this.isEdit) {
        const { status, msg } = await editBusiness({ ...values, id: this.id, pkInvoiceId: this.pkInvoiceId });
        this.successTip(status, msg);
      } else {
        const { status, msg } = await createBusiness(values);
        this.successTip(status, msg);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip(status: any, msg?: any) {
    if (status === '9999') {
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('create');
      this.modefind = '1';
      this.parkList = [];
      this.$emit('checkoutShowFlag', false);
    } else {
      this.$message.error(msg ? msg : `${this.isEdit ? '编辑' : '新增'}失败`);
    }
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  async mounted() {
    this.init();
  }
  // showFlag = false
  typeChange(e: string) {
    if (e === '04') {
      // this.showFlag = true
      this.$emit('checkoutShowFlag', true);
    } else {
      this.$emit('checkoutShowFlag', false);
    }
  }
  parkList = [];
  async orgdepChange(e: any) {
    try {
      this.parkList = [];
      this.form.setFieldsValue({ parkIds: [] });
      const res = await findParkByOrgId({ orgdepId: e });
      if (res.data.length > 0) {
        this.parkList = res.data.map((item: any) => {
          return { label: item.name, value: item.pkParkId };
        });
        // this.parkList.unshift({ label: '全部', value: 'all' })
      } else {
        this.parkList = [];
      }
    } catch (e) {
      console.log(e);
    }
  }
  async getpark(e: any) {
    try {
      const res = await findParkByOrgId({ orgdepId: e });
      this.parkList = res.data.map((item: any) => {
        return { label: item.name, value: item.pkParkId };
      });
      // this.parkList.unshift({ label: '全部', value: 'all' })
    } catch (e) {
      console.log(e);
    }
  }
}
